import React, { useState, useEffect } from 'react'
import GMap from './Signup/GMap';
import { useLocation, Link } from "react-router-dom";
import axios from 'axios';
import {
	CCard, CCol, CRow, CCardHeader,
	CCardTitle, CCardText, CCardBody,
	CCardSubtitle,
} from 'compat/coreui';


function SearchBusiness(props) {

	const [sellerData, setSellerData] = useState([]);
	const [params, setParams] = useState({});
	const location = useLocation();

	useEffect(() => {
		window.scrollTo(0, 0)
		setParams(location.state || {});
		getBusiness(location.state || {});
	}, [location]);

	const getBusiness = (paramsOne) => {
		console.log('inside getbusiness', paramsOne)
		axios.get(`${process.env.REACT_APP_APP_API_URL}/api/sellers`, {
			headers: {
				Authorization: 'Bearer ' + localStorage.getItem('token')
			},
			params: paramsOne
		}).then(res => {
			console.log("search business page", res)
			if (res.data.status === 200) {
				setSellerData(res.data.sellers)
			}
		}).catch(console.log)
	}


	return (
		<>
			<div>
				<div className="body_wrap has_map">
					<div>
						<div className="index_none2 remove_onreload">
							<div className="seller-details m-5">
								<h2 className="jp-results-heading">Businesses <span className="jp-results-count">{sellerData.length} found</span></h2>
								<CRow className="seller-cardRow">
									{sellerData.map((item, index) => {
										return (<CCol lg="4" md="6" key={index}>
											<Link to={`/businessnew/${item._id}`} className="jp-biz-card-link">
												<CCard className="jp-biz-card">
													<CCardBody className="d-flex p-0">
														<img className="jp-biz-avatar" alt="" src={item.image ? "https://pub-94bb2fa9f3f74a4d814557af59abaf7f.r2.dev/seller/" + item.image : "/images/44.png"} />
														<div className="bdetails-section">
															<CCardTitle>
																<span className="jp-biz-name">{item.businessName}</span><br />
																<span className="jp-card-type">{item.businessType}</span><br />
																<span className="jp-biz-location">{item.city}{item.city && item.state ? ', ' : ''}{item.state}</span>
															</CCardTitle>
															<span className="jp-stars" aria-label="rating">★★★★★</span>
														</div>
													</CCardBody>
												</CCard>
											</Link>
										</CCol>)
									})}
									{sellerData.length === 0 && <CCol className="jp-empty-state">
										<p>No businesses match your search yet — try a different city or zip code.</p>
									</CCol>}
								</CRow>
							</div>
							<div className="news_wrap">
								<div className="wrapper">
									<h2>Dulles Marijuana News &amp; Events</h2>
									<ul>
										<li><a href="#">
											<div className="img_wrap">
												<picture><img src="images/c.jpg" alt="Movement Toward Cannabis" /></picture>
												<h4>Movement Toward Cannabis Appellations: Why It's Important</h4>
											</div>
											<div className="cat_wrap business"><span>Education</span></div>
											<div className="date">December 21, 2020</div>
											<div className="split"><span /></div>
											<p>The cannabis industry has been rapidly growing since the first few states legalized recreational marijuana. Now that there are 15 fully legalized states and 35 states with legalized medical marijuana, it's more important than ever to create systems o...</p>
										</a></li>
										<li><a href="#">
											<div className="img_wrap">
												<picture>
													<img src="images/w.png" alt="Weed" />
												</picture>
												<h4>Why is France Giving Away Free Weed?</h4>
											</div>
											<div className="cat_wrap business"><span>Education</span></div>
											<div className="date">December 20, 2020</div>
											<div className="split"><span /></div>
											<p>French marijuana laws are conservative, especially when compared to other countries in the European Union. However, this month the French government released a&nbsp;decree detailing the country's plan for a limited medical marijuana experiment&nbsp;t...</p>
										</a></li>
										<li><a href="#">
											<div className="img_wrap">
												<picture>
													<img src="images/holiday.png" alt="Top 5 Holiday Movies to Smoke Weed With" /></picture>
												<h4>Top 5 Holiday Movies to Smoke Weed With</h4>
											</div>
											<div className="cat_wrap business"><span>Culture</span></div>
											<div className="date">December 19, 2020</div>
											<div className="split"><span /></div>
											<p>Stoners absolutely love Christmas (or at least they should), and there are multiple reasons why: It's a national holiday so there's typically no work or school for a day or two. There's yummy food for Christmas dinner, as well as giving and receiving...</p>
										</a></li>
										<li><a href="#">
											<div className="img_wrap">
												<picture>
													<img src="images/smoke.png" alt="Top 7 Strains to Smoke this Holiday Season" /></picture>
												<h4>Top 7 Strains to Smoke this Holiday Season</h4>
											</div>
											<div className="cat_wrap business"><span>Strains &amp; Products</span></div>
											<div className="date">December 18, 2020</div>
											<div className="split"><span /></div>
											<p>COVID-19 has made this year a bit of a whirlwind, and it doesn't look like it is going to stop anytime soon. With the latest closures and possible cancellation of our beloved holidays, we all need a little something to take the edge off. Our favorite...</p>
										</a></li>
									</ul>
									<div className="more_cta"><a href="#"><span>More Articles</span></a></div>
								</div>
							</div>
							<div className="slide_split app_slide">
								<div className="wrapper">
									<div className="c_6 app_img"><img src="/images/app_cta.png" alt="App Homescreen" /></div>
									<div className="c_6 app_text">
										<h3>Get the app</h3>
										<p>Discover local businesses. Find the best deals. <span>Connect &amp; share with friends.</span></p>
										<ul className="app_links">
											<li className="app_logo"><a href="#" target="_blank" rel="noopener"><img src="/images/ply-str.png" alt="Android App" /></a></li>
											<li className="app_logo"><a href="#" target="_blank" rel="noopener"><img src="/images/ap-str.png" alt="iOS App" /></a></li>
											<li className="app_logo"><a href="#" target="_blank" rel="noopener"><img src="/images/wnd-str.png" alt="WindowsPhone App" /></a></li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}


export default SearchBusiness;